import ChallengeWork from "@/views/ChallengeWorks/ChallengeWorkList";
import ChallengeWorkMy from "@/views/ChallengeWorks/ChallengeWorkMy";
import ChallengeWorkDetail from "@/views/ChallengeWorks/ChallengeWorkDetail";
import HomeworkPlus from "@/views/Homework/HomeworkPlus";
import HomeWorkPlusMy from "@/views/Homework/HomeWorkPlusMy";
import HomeworkPlusMyDetail from "@/views/Homework/HomeworkPlusMyDetail";
import HomeworkProject from "@/views/Homework/HomeworkProject";
import HomeworkProjectMy from "@/views/Homework/HomeworkProjectMy";
import HomeworkProjectMyDetail from "@/views/Homework/HomeworkProjectMyDetail";
import Student from "@/views/Student/Student";
import StudentDetail from "@/views/Student/StudentDetail";
import StudentDetailTaskCreate from "@/views/Student/StudentDetailTaskCreate";
import StudentDetailTaskDetail from "@/views/Student/StudentDetailTaskDetail";

export default [
  {
    path: "service",
    name: "service",
    component: { render: h => h("router-view") },
    meta: {
      nav: {
        icon: "el-icon-s-marketing",
        title: "学员服务"
      },
      breadcrumb: {
        title: "学员服务",
        replace: false
      }
    },
    children: [
      {
        path: "challenge_work",
        name: "",
        component: { render: h => h("router-view") },
        meta: {
          title: "极客-挑战作品-挑战作品",
          nav: {
            icon: "el-icon-document",
            title: "挑战作品"
          },
          breadcrumb: {
            title: "挑战作品",
            replace: false
          }
        },
        children: [
          {
            path: "list",
            name: "ChallengeWork",
            redirect: { name: "ChallengeWorkSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "ChallengeWorkSelf",
                component: ChallengeWork,
                permission:
                  "expert_service.api.fuwu_admin.v2.expert.challenges.works.index",
                meta: {
                  title: "极客-挑战作品-作品列表",
                  nav: {
                    icon: "el-icon-tickets",
                    title: "作品列表"
                  },
                  breadcrumb: {
                    title: "作品列表",
                    replace: false
                  }
                }
              }
              //   {
              //     path: ":id/create",
              //     name: "ChallengeCreate",
              //     component: ChallengeCreate,
              //     permission: "challenge_service.api.fuwu_admin.my_challenges.store",
              //     meta: {
              //       title: "极客-挑战设计-创建挑战"
              //     }
              //   }
            ]
          },
          {
            path: "my",
            name: "ChallengeWorkMy",
            redirect: { name: "ChallengeWorkMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "ChallengeWorkMySelf",
                component: ChallengeWorkMy,
                permission:
                  "expert_service.api.fuwu_admin.v2.expert.challenges.works.evaluate",
                meta: {
                  title: "极客-挑战作品-我的批改",
                  nav: {
                    icon: "el-icon-tickets",
                    title: "我的批改"
                  },
                  breadcrumb: {
                    title: "我的批改",
                    replace: false
                  }
                }
              },
              {
                path: ":id",
                name: "ChallengeWorkDetail",
                component: ChallengeWorkDetail,
                permission:
                  "expert_service.api.fuwu_admin.v2.expert.challenges.works.show",
                meta: {
                  title: "极客-挑战作品-作品",
                  breadcrumb: {
                    title: "作品",
                    replace: false
                  }
                }
              }
            ]
          }

          //   {
          //     path: "my",
          //     name: "ChallengeMy",
          //     redirect: { name: "ChallengeMySelf" },
          //     component: { render: h => h("router-view") },
          //     children: [
          //       {
          //         path: "",
          //         name: "ChallengeMySelf",
          //         component: ChallengeMy,
          //         permission: "challenge_service.api.fuwu_admin.my_challenges.index",
          //         meta: {
          //           title: "极客-挑战设计-我的挑战",
          //           nav: {
          //             title: "我的挑战"
          //           }
          //         }
          //       },
          //       {
          //         path: ":id",
          //         name: "ChallengeDetail",
          //         component: ChallengeDetail,
          //         permission: "challenge_service.api.fuwu_admin.my_challenges.show",
          //         meta: {
          //           title: "极客-挑战详情"
          //         }
          //       }
          //     ]
          //   }
        ]
      },
      {
        path: "homework",
        name: "Homework",
        component: { render: h => h("router-view") },
        meta: {
          nav: {
            svg: {
              class: "nav-svg",
              name: "homework"
            },
            title: "作业批改"
          },
          breadcrumb: {
            title: "作业批改",
            replace: false
          }
        },
        children: [
          {
            path: "project",
            name: "HomeworkProject",
            redirect: { name: "HomeworkProjectSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "HomeworkProjectSelf",
                component: HomeworkProject,
                permission: "expert_service.api.fuwu_admin.homeworks.index",
                meta: {
                  title: "极客-作业批改-项目",
                  nav: {
                    title: "项目作业"
                  },
                  breadcrumb: {
                    title: "项目作业",
                    replace: false
                  }
                }
              },
              {
                path: "my",
                name: "HomeworkProjectMy",
                redirect: { name: "HomeworkProjectMySelf" },
                component: { render: h => h("router-view") },
                children: [
                  {
                    path: "",
                    name: "HomeworkProjectMySelf",
                    component: HomeworkProjectMy,
                    permission:
                      "expert_service.api.fuwu_admin.homeworks.evaluate_list",
                    meta: {
                      title: "极客-作业批改-我的批改（项目）",
                      nav: {
                        title: "我的批改（项目）"
                      },
                      breadcrumb: {
                        title: "我的批改（项目）",
                        replace: false
                      }
                    }
                  },
                  {
                    path: ":id",
                    name: "HomeworkProjectMyDetail",
                    component: HomeworkProjectMyDetail,
                    permission:
                      "expert_service.api.fuwu_admin.homeworks.evaluate_show",
                    meta: {
                      title: "极客-作业批改-项目",
                      breadcrumb: {
                        title: "项目",
                        replace: false
                      }
                    }
                  }
                ]
              }
            ]
          },
          {
            path: "plus",
            name: "HomeworkPlus",
            redirect: { name: "HomeworkPlusSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "HomeworkPlusSelf",
                component: HomeworkPlus,
                permission: "expert_service.api.fuwu_admin.homeworks.index",
                meta: {
                  title: "极客-作业批改-实战营",
                  nav: {
                    title: "实战营作业"
                  },
                  breadcrumb: {
                    title: "实战营作业",
                    replace: false
                  }
                }
              },
              {
                path: "my",
                name: "HomeWorkPlusMy",
                redirect: { name: "HomeWorkPlusMySelf" },
                component: { render: h => h("router-view") },
                children: [
                  {
                    path: "",
                    name: "HomeWorkPlusMySelf",
                    component: HomeWorkPlusMy,
                    permission:
                      "expert_service.api.fuwu_admin.homeworks.evaluate_list",
                    meta: {
                      title: "极客-作业批改-我的批改（实战营）",
                      nav: {
                        title: "我的批改（实战营）"
                      },
                      breadcrumb: {
                        title: "我的批改（实战营）",
                        replace: false
                      }
                    }
                  },
                  {
                    path: ":id",
                    name: "HomeworkPlusMyDetail",
                    component: HomeworkPlusMyDetail,
                    permission:
                      "expert_service.api.fuwu_admin.homeworks.evaluate_show",
                    meta: {
                      title: "极客-作业批改-实战营",
                      breadcrumb: {
                        title: "实战营",
                        replace: false
                      }
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: "student",
        name: "Student",
        redirect: { name: "StudentSelf" },
        component: { render: h => h("router-view") },
        meta: {
          nav: {
            icon: "el-icon-user-solid",
            title: "学员辅导"
          },
          breadcrumb: {
            title: "学员辅导",
            replace: false
          }
        },
        children: [
          {
            path: "",
            name: "StudentSelf",
            component: Student,
            permission: "gongfu.api.fuwu_admin.study_paths.index",
            meta: {
              title: "极客-我的学员",
              nav: {
                icon: "el-icon-user-solid",
                title: "我的学员"
              },
              breadcrumb: {
                title: "我的学员",
                replace: false
              }
            }
          },
          {
            path: ":id",
            name: "StudentDetail",
            redirect: { name: "StudentDetailSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "StudentDetailSelf",
                permission: "gongfu.api.fuwu_admin.study_paths.show",
                component: StudentDetail
              },
              {
                path: "task/create",
                name: "StudentDetailTaskCreate",
                permission: "gongfu.api.fuwu_admin.study_paths.tasks.store",
                component: StudentDetailTaskCreate
              },
              {
                path: "task/:taskId",
                name: "StudentDetailTaskDetail",
                permission: "gongfu.api.fuwu_admin.study_paths.tasks.show",
                component: StudentDetailTaskDetail
              }
            ]
          }
        ]
      }
    ]
  }
];
